export default __webpack_public_path__ + "static/1323-15fea88e4ce659ecad480efc94305725.gif";